;$(function() {
	function closeAllPopup() {
		$('.menu-button_active').removeClass('menu-button_active');
		$('.menu__button_active').removeClass('menu__button_active');
		$('.tabs__button_active[data-type=open-tabs]').removeClass('tabs__button_active');
		$('.tabs__list_shown').removeClass('tabs__list_shown');
	};

	$(document).click( closeAllPopup );
	$(window).resize( closeAllPopup );
});